import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { RemoteUserTermsAgreesRepo } from '@repository/userTermsAgrees/UserTermsAgreesRepo';

const remoteUserTermsAgreesRepo = new RemoteUserTermsAgreesRepo();

const fetchTermsAccaAgree = async (id: string) => {
  const { data } = await remoteUserTermsAgreesRepo.fetchTermsAccaAgree(id);
  return data;
};

export function useTermsAccaAgree(onSuccess: (result: boolean) => void, onError: (code: string) => void) {
  return useMutation((id: string) => fetchTermsAccaAgree(id), {
    onSuccess: (result: boolean) => onSuccess(result),
    onError: (error: AxiosError) => {
      console.log(error.response?.data);
      onError(error.response?.data.errorCode ?? '');
      return;
    },
  });
}
